import React, { FC, useRef } from "react";
import { useDrag } from "react-dnd";
import { useSelector } from "react-redux";
import { Tooltip } from "react-tippy";
import { dropSection } from "../../actions/sectionListAction";
import { AppState } from "../../reducers/rootReducer";
import { getFormById } from "../../selectors/formSelector";
import { ItemTypes } from "../../utils/itemTypes";
import "./elementpanel.scss";

export interface ElementItemProps {
  name: String;
  category: String;
  type: String;
  icon: string;
  url: string;
}
const ElementItem: FC<ElementItemProps> = (props) => {
  const ref = useRef<HTMLLIElement>(null);
  const sessionState = useSelector((state: AppState) => state.session);
  const selectedForm = useSelector(getFormById(sessionState.selectedFormId));

  // make element draggable

  const [, drag] = useDrag({
    type: props.category == "element" ? ItemTypes.ELEMENT : ItemTypes.LAYOUT,
    item: {
      type: props.type,
      category: props.category,
    },
  }); //

  if (selectedForm && selectedForm.type !== "alert") {
    drag(ref);
  }
  return (
    <li ref={ref} className="element-item m-1 display-inline">
      <div
        className={`col-12  ${
          (selectedForm && selectedForm.type === "alert") ??
          "disableElementPanal"
        }`}
      >
        <div className="row mt-2">
          <div className="element-card">
            {(props.type === "tab" ||
              props.type === "table" ||
              props.type === "collaps") && (
              <Tooltip title="Preview download under construction">
                <img className={props.icon} src={props.url}></img>
                <div className="label-name">{props.name}</div>
              </Tooltip>
            )}
            {(props.type !== "tab" &&
              props.type !== "table" &&
              props.type !== "collaps") && (
              <>
                <img className={props.icon} src={props.url}></img>
                <div className="label-name">{props.name}</div>
              </>
            )}
          </div>
          {/* <div className="col-9">
                        <span className="label-name">{props.name}</span>
                    </div> */}
        </div>
      </div>
    </li>
  );
};

export default ElementItem;
